/**
 * Zod 4 compile ses analyseurs d'objets avec `new Function` : la politique de
 * sécurité de l'application web (`script-src 'self'`, sans `'unsafe-eval'`) le
 * signale à chaque page. Sans compilation, les résultats de validation sont les
 * mêmes. Importé en premier par `index.ts`, avant tout `z.object`.
 */
import { z } from 'zod';

z.config({ jitless: true });
